import { post,  get }  from '@/axios/method';

// 获取指定活动的报名配置 [易聪林](http://yapi.dev.anoah.com/project/1225/interface/api/55262)
export const getActivityApplyConfig = (data) => post('/api/dm/clue/activity/getActivityApplyConfig', data);

// 获取地区列表 [易聪林](http://yapi.dev.anoah.com/project/1225/interface/api/55824?from_wecom=1)
export const getAreaList = () => get('/api/dm/data/lbsarea/areaList');

// 获取推荐导购 [易聪林](http://yapi.dev.anoah.com/project/1225/interface/api/55260)
export const getRecommendUserInfo = (data) => post('/api/dm/clue/activity/getRecommendUserInfo', data);  

// 提交参与活动申请 [易聪林](http://yapi.dev.anoah.com/project/1225/interface/api/55266)
export const applyActivity = (data) => post('/api/dm/clue/activity/applyActivity',data);  

// 获取提交表单授权key [易聪林](http://yapi.dev.anoah.com/project/1225/interface/api/55512)
export const getAuthKey = () => get('/api/dm/clue/activity/getAuthKey');

// 获取提交表单授权key [王建涛](http://yapi.dev.anoah.com/project/1225/interface/api/55694)
export const getRecruitment = (data) => get('/api/dm/market/recruitment/detail', { data });